// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"639d122d","678":"6451cd90","845":"ed0c19e3"}[chunkId] + ".chunk.js";
};